"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect, useCallback, ReactNode } from "react";
interface CarouselProps {
  children: ReactNode[];
  className?: string;
  dotContainerClassName?: string;
  dotActiveClassName?: string;
  dotInactiveClassName?: string;
}
export const Carousel = t0 => {
  const $ = _c(23);
  const {
    children,
    className: t1,
    dotContainerClassName: t2,
    dotActiveClassName: t3,
    dotInactiveClassName: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const dotContainerClassName = t2 === undefined ? "" : t2;
  const dotActiveClassName = t3 === undefined ? "" : t3;
  const dotInactiveClassName = t4 === undefined ? "" : t4;
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);
  let t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const el = scrollRef.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const slides = Array.from(el.children);
            const index = slides.indexOf(entry.target as HTMLElement);
            if (index !== -1) {
              setActiveIndex(index);
            }
          }
        });
      }, {
        root: el,
        threshold: 0.5
      });
      Array.from(el.children).forEach(child => observer.observe(child));
      return () => observer.disconnect();
    };
    t6 = [];
    $[0] = t5;
    $[1] = t6;
  } else {
    t5 = $[0];
    t6 = $[1];
  }
  useEffect(t5, t6);
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = index_0 => {
      const el_0 = scrollRef.current;
      if (!el_0) {
        return;
      }
      el_0.scrollTo({
        left: index_0 * el_0.offsetWidth,
        behavior: "smooth"
      });
    };
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const scrollTo = t7;
  const t8 = `relative ${className}`;
  let t9;
  if ($[3] !== children) {
    t9 = React.Children.map(children, _temp);
    $[3] = children;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== t9) {
    t10 = <div ref={scrollRef} className="flex h-full overflow-x-scroll snap-x snap-mandatory no-scrollbar overscroll-x-contain">{t9}</div>;
    $[5] = t9;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const t11 = `absolute left-0 right-0 flex justify-center items-center z-20 pointer-events-none list-none m-0 p-0 ${dotContainerClassName}`;
  let t12;
  if ($[7] !== activeIndex || $[8] !== children || $[9] !== dotActiveClassName || $[10] !== dotInactiveClassName) {
    let t13;
    if ($[12] !== activeIndex || $[13] !== dotActiveClassName || $[14] !== dotInactiveClassName) {
      t13 = (_, i) => <li key={i} onClick={() => scrollTo(i)} className={`inline-block mx-1.5 rounded-full cursor-pointer transition-all duration-300 ease-in-out pointer-events-auto ${activeIndex === i ? dotActiveClassName : dotInactiveClassName}`} />;
      $[12] = activeIndex;
      $[13] = dotActiveClassName;
      $[14] = dotInactiveClassName;
      $[15] = t13;
    } else {
      t13 = $[15];
    }
    t12 = React.Children.map(children, t13);
    $[7] = activeIndex;
    $[8] = children;
    $[9] = dotActiveClassName;
    $[10] = dotInactiveClassName;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <ul className={t11}>{t12}</ul>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10 || $[20] !== t13 || $[21] !== t8) {
    t14 = <div className={t8}>{t10}{t13}</div>;
    $[19] = t10;
    $[20] = t13;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};
function _temp(child_0) {
  return <div className="flex-none w-full h-full snap-start">{child_0}</div>;
}